import { render, staticRenderFns } from "./WorkPrompt.vue?vue&type=template&id=406111a0&"
import script from "./WorkPrompt.vue?vue&type=script&lang=js&"
export * from "./WorkPrompt.vue?vue&type=script&lang=js&"
import style0 from "./WorkPrompt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports